module.exports = __webpack_public_path__ + "static/media/login_logo_loistelampo.027b7808.svg";